import { SVGProps } from 'react'

export function DottedDivider(props: SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="81" height="1" viewBox="0 0 81 1" fill="none" {...props}>
            <path d="M0.5 0.5H80.5" stroke="#E7E7E7" stroke-linecap="round" stroke-dasharray="0.1 2" />
        </svg>
    )
}
